import Icon from "react-web-vector-icons";
import QueryRow from "./QueryRow";
import "./SequenceConfig.scss";

const SequenceConfig = ({
  sequence,
  sequenceIndex,
  vendor,
  onRowChange,
  onRowDelete,
  onRowAdd,
  onClose,
}) => {
  if (!sequence || sequence.length === 0) {
    return (
      <div className="sequence-config-empty">
        <p>Select a sequence or add a new one to configure filters</p>
      </div>
    );
  }

  return (
    <div className="sequence-config-container">
      <div className="close-icon" onClick={onClose}>
        <Icon name="close" font="AntDesign" color="#142A31" size={20} />
      </div>

      <div className="sequence-config-body">
        {sequence.map((row, rowIndex) => (
          <div key={row.key} className="config-row-wrapper">
            {rowIndex > 0 && (
              <div className="and-badge">
                <span>AND</span>
              </div>
            )}
            <div className="config-row-content">
              <QueryRow
                showDelete={rowIndex > 0}
                row={row}
                vendor={vendor}
                onChange={onRowChange}
                onDelete={() => onRowDelete(row.key)}
                onAdd={() => onRowAdd(row.key)}
              />
            </div>
          </div>
        ))}

        {sequence.length < 4 && (
          <div className="add-row-section">
            <button
              className="add-and-btn"
              onClick={() => onRowAdd(sequence[sequence.length - 1].key)}
            >
              <Icon name="plus" font="AntDesign" color="#FFFFFF" size={16} />
              <span>And</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SequenceConfig;
